import ContractTaxiDriverAddRequest, {
  ContractTaxiDriverAddRequestModel,
} from "../../../../api/raily/contracts/taxi-driver/add/contracts-taxi-driver-add.request";
import BillingModel from "../../../../types/billing-model";
import ContractsTaxiDriverAddParams from "./contracts-taxi-driver-add-params";

const createModel = (
  model: BillingModel,
): ContractTaxiDriverAddRequestModel => {
  switch (model) {
    case BillingModel.AB:
      return ContractTaxiDriverAddRequestModel.AB;
    case BillingModel.ABA:
      return ContractTaxiDriverAddRequestModel.ABA;
    case BillingModel.OTHER:
      return ContractTaxiDriverAddRequestModel.OTHER;
    case BillingModel.SABS:
      return ContractTaxiDriverAddRequestModel.SABS;
  }
};

const create = (
  params: ContractsTaxiDriverAddParams,
): ContractTaxiDriverAddRequest => {
  return {
    description: params.description,
    disabled: params.disabled,
    distanceRate: params.distanceRate,
    haltingTimeAfterMinutes: params.haltingTimeAfterMinutes,
    haltingTimeRate: params.haltingTimeRate,
    model: createModel(params.model),
    taxiDriverAssociationId: params.taxiDriverAssociationId,
    validSince: params.validSince,
    validTo: params.validTo,
  };
};

const contractsTaxiDriverAddParamsFactory = {
  create,
};

export default contractsTaxiDriverAddParamsFactory;
